import { useId, useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
type Side = {
  image: string;
  label: string;
};
type Props = {
  before: Side;
  after: Side;
};

/**
 * Voor/na-schuif, gedeeld door het fotodagboek in Mijn omgeving en het klantdossier
 * in het beheer. Het bereik is een gewoon range-veld, dus ook met toetsenbord en
 * schermlezer te bedienen.
 */
export function CompareSlider({
  before,
  after
}: Props) {
  const [pos, setPos] = useState(50);
  // Eigen id per schuif: twee schuiven op één pagina mogen elkaars label niet lenen.
  const id = useId();
  return <div className="relative aspect-[3/4] w-full select-none overflow-hidden bg-sand sm:aspect-[4/5]" data-id="element-8807" data-mp="18cmduogdk9n8">
      <img src={after.image} alt={after.label} className="absolute inset-0 h-full w-full object-cover" draggable={false} data-id="element-8808" data-mp="13dj6uygu3tcm" />
      <img src={before.image} alt={before.label} className="absolute inset-0 h-full w-full object-cover" style={{
      clipPath: `inset(0 ${100 - pos}% 0 0)`
    }} draggable={false} data-id="element-8809" data-mp="20t6uieth1t02" />

      <span className="absolute left-3 top-3 rounded-full bg-ink/75 px-3 py-1 text-[12px] text-shell backdrop-blur-sm" aria-hidden="true" data-id="element-8810" data-mp="3uvaltrs53g03">
        {before.label}
      </span>
      <span className="absolute right-3 top-3 rounded-full bg-shell/90 px-3 py-1 text-[12px] text-ink backdrop-blur-sm" aria-hidden="true" data-id="element-8811" data-mp="3l4y5kbrcy8zr">
        {after.label}
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-px bg-shell" style={{
      left: `${pos}%`
    }} data-id="element-8812" data-mp="3c3hv640jm6vj">
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-shell text-ink shadow-knob" data-id="element-8813" data-mp="3g4tookmjfc90">
          <MoveHorizontalIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-8814" data-mp="327eqori7xw5f" />
        </span>
      </div>

      <label className="sr-only" htmlFor={id} data-id="element-8815" data-mp="10dxm5wpdxbew">
        Schuif tussen {before.label} en {after.label}
      </label>
      <input id={id} type="range" min={0} max={100} value={pos} onChange={e => setPos(Number(e.target.value))} className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-8816" data-mp="15dk2if0if7rx" />
    </div>;
}